// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GRWyADjhck4ETLA0g7EY{background:var(--background-primary-inverted-primary);border-radius:4px;justify-content:center;align-items:center;min-width:20px;height:20px;margin-top:-3px;margin-bottom:-3px;display:flex}.svnvYVWUbuAQmp2xkIsA{justify-content:space-between;align-items:center;width:100%;display:flex}.enx4rCm686Ys2pp3Oo8N{justify-content:flex-start;align-items:center;display:flex}.rNiXFTm9fnAHXgOC4gmT{color:var(--action-contained-primary-normal);margin-right:8px}.rNiXFTm9fnAHXgOC4gmT:hover{color:var(--action-contained-primary-hovered)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `GRWyADjhck4ETLA0g7EY`,
	"title": `svnvYVWUbuAQmp2xkIsA`,
	"action": `enx4rCm686Ys2pp3Oo8N`,
	"button": `rNiXFTm9fnAHXgOC4gmT`
};
export default ___CSS_LOADER_EXPORT___;
